module.exports = __webpack_public_path__ + "img/icon-16-date-2.43178f68.svg";